import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createStoreOwner(data) {
  return axiosInstance.post(`admin/store-owner/create`, data);
}

export function updateStoreOwner(data) {
  return axiosInstance.post(`admin/store-owner/update`, data);
}

export function getStoreOwnerList(data) {
  return axiosInstance.post(`admin/store-owner/list`, formatRequest(data));
}

export function getStoreOwnerDetails(data) {
  return axiosInstance.post(`admin/store-owner/details`, formatRequest(data));
}

export function deleteStoreOwner(data) {
  return axiosInstance.post(`admin/store-owner/delete`, formatRequest(data));
}

